import { useEffect, useState } from "react"
import Recorder from "recorder-js"
import secureLocalStorage from "react-secure-storage"
const useRecording = () => {
  const [audioURL, setAudioURL] = useState(null)
  const [isRecording, setIsRecording] = useState(false)
  const [recorder, setRecorder] = useState(null)
  const [stream, setStream] = useState(null)

  useEffect(() => {
    if (recorder === null) {
      return
    }
    // Obtain the audio when ready.
    // const handleData = (e) => {
    //   // setAudioURL(URL.createObjectURL(e.data));
    //   setAudioURL(e.data)
    //   stopRecording()
    // }
    // recorder.addEventListener("dataavailable", handleData)
    return () => {
      // recorder.removeEventListener("dataavailable", handleData)
      try {
        recorder.stream.getTracks().forEach((track) => track.stop())
      } catch (error) {}
    }
  }, [recorder])

  const initStream = (streamRef) => {
    setStream(streamRef)
  }

  const startRecording = async () => {
    setIsRecording(true)
    try {
      setAudioURL(null)
      const recorder = await requestRecorder(stream)
      setRecorder(recorder)
      recorder.start()
    } catch (error) {
      console.error(error)
      setIsRecording(false)
    }
  }

  const stopRecording = async () => {
    setIsRecording(false)
    try {
      if (!recorder) {
        console.warn("recorder is null")
        return
      }
      const { blob } = await recorder.stop()
      setAudioURL(blob)
      // // stop microphone access
      // await recorder.stream.getTracks().forEach((track) => track.stop())
    } catch (error) {
      setRecorder(null)
    }
  }

  const resetRecorder = () => {
    if (recorder !== null) {
      try {
        recorder.stream.getTracks().forEach((track) => track.stop())
      } catch (error) {}
    }
    setRecorder(null)
    setIsRecording(false)
    setAudioURL(null)
  }

  return [
    audioURL,
    isRecording,
    startRecording,
    stopRecording,
    initStream,
    resetRecorder,
  ]
}

async function requestRecorder(streamRef) {
  const audioContext = new (window.AudioContext || window.webkitAudioContext)()
  if (!audioContext) {
    return null
  }
  let stream = streamRef
  if (!streamRef) {
    const deviceId =
      JSON.parse(secureLocalStorage.getItem("smashUserSettings")) || null
    stream = await navigator?.mediaDevices?.getUserMedia({
      audio: deviceId !== null ? { deviceId } : true,
    })
  }
  try {
    const recorder = new Recorder(audioContext)
    recorder.init(stream)
    return recorder
  } catch (error) {
    console.log("🚀 ~ requestRecorder ~ error:", error)
    return null
  }
}
export default useRecording
